import AbstractMetadata from "../AbstractMetadata";

class PicklistMetadata extends AbstractMetadata {
    bounded: boolean = false;
    enterpriseComponent: string | null = null;
    longList: boolean = false;
    noDelete: boolean = true;
    noUpdate: boolean = true;
    noInsert: boolean = true;
    noMerge: boolean = true;
    useRealm: boolean = true;
    searchSpecification: object | null = null;
    sortSpecification: object | null = null;
    static: boolean = true;
    typeField: string | null = "Pick Type";
    typeValue: string | null = null;
    typeValue2: string | null = null;
    visibilityType: string | null = null;
    allowNoSelection: boolean = false;
    allowNoSelectionDisplayValue: string | null= "None";
    allowNoSelectionValue: boolean = false;

    // Indented-hierarchy dropdown: when true, PlatformSelect orders the (EC-sourced) options as a tree
    // and indents each MenuItem by its depth, instead of a flat list. hierarchyParentField names the
    // buffer field on each option that holds its PARENT's value (which must equal another option's
    // typeValue) — e.g. "ParentUSID" for Positions. Options whose parent is null/absent (or whose
    // parent was filtered out of the list) become roots. Value model is unchanged (still typeValue).
    hierarchical: boolean = false;
    hierarchyParentField: string | null = null;

    // Optional secondary value appended to each option's display, e.g. "Name (Primary User: Jane Doe)".
    // secondaryDisplayField names the buffer field to read; secondaryDisplayLabel is the "(<label>: …)"
    // prefix (omit the label to render just "(<value>)"). Only appended when the field has a value.
    secondaryDisplayField: string | null = null;
    secondaryDisplayLabel: string | null = null;

    getHierarchical(): boolean {
        return this.hierarchical;
    }

    getHierarchyParentField(): string | null {
        return this.hierarchyParentField;
    }

    getSecondaryDisplayField(): string | null {
        return this.secondaryDisplayField;
    }

    getSecondaryDisplayLabel(): string | null {
        return this.secondaryDisplayLabel;
    }

    getBounded(): boolean {
        return this.bounded;
    };

    getEnterpriseComponent(): string | null {
        return this.enterpriseComponent;
    };

    getLongList(): boolean {
        return this.longList;
    };

    getNoDelete(): boolean {
        return this.noDelete;
    };

    getNoInsert(): boolean {
        return this.noInsert;
    };

    getNoUpdate(): boolean {
        return this.noUpdate;
    };

    getNoMerge() : boolean {
        return this.noMerge;
    };

    getUseRealm() : boolean {
        return this.useRealm;
    };

    getSearchSpecification(): object | null {
        return this.searchSpecification;
    };

    getSortSpecification(): object | null {
        return this.sortSpecification;
    };

    getStatic(): boolean {
        return this.static;
    };

    getTypeField(): string | null {
        return this.typeField;
    };

    getTypeValue(): string | null {
        return this.typeValue;
    };

    getTypeValue2(): string | null {
        return this.typeValue2;
    };

    getVisibilityType(): string | null {
        return this.visibilityType;
    };

    getAllowNoSelection(): boolean {
        return this.allowNoSelection;
    };

    getAllowNoSelectionDisplayValue(): string | null {
        return this.allowNoSelectionDisplayValue;
    };

    getAllowNoSelectionValue(): boolean {
        return this.allowNoSelectionValue;
    };
}

export default PicklistMetadata;
